$(function () {
    var $container = $('#form-add-invoice');
    var $table = $('#products_invoice');
    var template = $('#template-product').html();
    var $total = $('#total');
    var $discount = $('#discount');
    var $discount_percentage = $('#discount_percentage');
    var $tax = $('#tax');
    var abroad_invoice = false;
    var company_invoice = false;
    var zero_tax = false;

    $('#product-invoice').select2();

    $('#abroad_invoice').on('ifChanged', function (event) {
        abroad_invoice =  $(this).prop('checked');
        calculateAll();
    });

    $('#invoice_company').on('ifChanged', function (event) {
        company_invoice = $(this).prop('checked');
        calculateAll();
    });

    $('#zero_tax').on('ifChanged', function (event) {
        zero_tax = $(this).prop('checked');
        calculateAll();
    });

    var input_has_value = $('.discount-product').filter(function () {
        return $(this).val();
    });

    if (input_has_value.length > 0) {
        $('#discount').prop('disabled', true);
    }

    $container
        .on('click', '.add-product', function () {
            var text = $('#product-invoice option:selected').text();
            var price = $('#product-invoice option:selected').attr('data-price');
            var id = $('#product-invoice option:selected').val();

            var row = $(template).clone();

            $(row).attr('data-id', id);
            $(row).find('td.title').append(text);

            //Delivery
            if (id == 28) {
                $(row).find('.price')
                    .html('<input type="text" class="form-control" name="price[]" id="price" value="' + price + '">');
            }
            else {
                $(row).find('.price').text(price);
            }

            $(row).find('.total').text(price);
            $(row).find('.product-id').val(id);

            $table.find('tbody').append(row);

            if ($('#discount').val().length > 0) {
                $(row).find('.discount-product').prop('disabled', true);
            }

            calculateAll();
        });

    $table
        .on('click', '.btn-delete-product', function () {
            $(this).closest('tr').remove();
            calculateAll();
        })
        .on('input', '.quantity', function () {
            var quantity = parseInt($(this).val());
            var discount = parseFloat($(this).closest('tr').find('.discount-product').val());
            var price;

            if ($(this).closest('tr').find('.price').find('#price').length > 0) {
                price = parseFloat($(this).closest('tr').find('.price').find('#price').val( ));
            }
            else {
                price = parseFloat($(this).closest('tr').find('.price').text());
            }

            price = quantity * price;
            var total = price;

            if (!isNaN(discount)) {
                total = (price - (price * discount)  / 100).toFixed(2);
            }

            $(this).closest('tr').find('.total').text(total);

            calculateAll();
        })
        .on('input', '.discount-product', function () {
            var discount = parseFloat($(this).val());

            var price = parseFloat($(this).closest('tr').find('.price').text());
            var quantity = parseInt($(this).closest('tr').find('.quantity').val());
            price = price * quantity;
            var total = price;

            if (!isNaN(discount)) {
                total = (price - (price * discount)  / 100).toFixed(2);
            }

            if ($(this).val().length > 0) {
                $('#discount').prop('disabled', true);
            } else {
                $('#discount').prop('disabled', false);
            }

            $(this).closest('tr').find('.total').text(total);
            calculateAll();
        })
        .on('input', '#price', function () {
            var quantity = parseInt($(this).closest('tr').find('.quantity').val());
            var price = parseFloat($(this).closest('tr').find('.price').find('#price').val( ));
            var total = quantity * price;

            $(this).closest('tr').find('.total').text(total);

            calculateAll();
        });

    $discount.on('input', function () {
        if ($(this).val().length > 0) {
            $('.discount-product').prop('disabled', true);
        } else {
            $('.discount-product').prop('disabled', false);
        }

        calculateAll();
    });

    var calculateAll = function () {
        var total = 0;
        var discount = $discount.val();
        var discount_percentage;
        var tax = 0;
        var tax_percentage = 0.180328;

        $table.find('tr').not(':first').each(function () {
            var $row = $(this);
            total += parseFloat($row.find('.total').text());
            if ($row.attr('data-id') == 12) {
                tax_percentage = 0.086758;
            }
        });

        if (discount !== '') {
            discount_percentage = (1 - (parseFloat(discount) / parseFloat(total))) * 100;
            $discount_percentage.val(discount_percentage.toFixed(2));

            tax = Math.floor(parseFloat(discount * tax_percentage) * 100) / 100;
        }
        else {
            $discount_percentage.val('');
            tax = Math.floor(parseFloat(total * tax_percentage) * 100) / 100;
        }

        if (abroad_invoice || company_invoice || zero_tax) {
            tax = 0;
        }

        $total.val(total.toFixed(2));
        $tax.val(tax.toFixed(2));
    };
});

